export const HEADER = {
  contentTypes: {
    json: 'application/json',
  },
};
